// Plan ▸ Timeline: calendar lanes of the characters across the days of the story, or the charts in reading order.
export { TimelinePage as component, TimelineControls as headerControls } from '../../views/story/TimelinePage.tsx';
export { StoryColumn as column } from '../../views/story/StoryColumn.tsx';
export const room = 'plan';
export const page = 'timeline';
export const title = 'Timeline';
export const help = 'story-view';
export const columnTitle = 'People';
